// src/components/MainLayout.js
import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemText,
  Box, IconButton, Menu, MenuItem, Avatar
} from '@mui/material';
import { Link, Outlet, useNavigate } from 'react-router-dom';

const MainLayout = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const user = localStorage.getItem('user');
  const secciones = JSON.parse(localStorage.getItem('secciones') || '[]');

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Opcional: llamar al backend para logout (no obligatorio si usas tokens stateless)
    // fetch('/api/login/', { method: 'POST', body: JSON.stringify({ accion: 'Salir' }) });

    // Limpiar datos de sesión
    localStorage.removeItem('user');
    localStorage.removeItem('secciones');

    // Cerrar menú y redirigir
    handleMenuClose();
    navigate('/login');
  };

  const enlaceToRuta = (enlace) => {
  // Módulos principales del POA
  if (enlace === 'poa_proyecto.php') return '/poa';
  if (enlace === 'meta.php') return '/metas-globales';
  if (enlace === 'matriz.php') return '/matriz';
  if (enlace === 'vinculacion.php') return '/vinculacion';
  
  // Catálogos base (los que acabas de agregar)
  if (enlace === 'sector.php') return '/sectores';
  if (enlace === 'programa.php') return '/programas';
  if (enlace === 'proyecto.php') return '/proyectos';
  if (enlace === 'departamento.php') return '/departamentos';
  
  // Otros (si los tienes en tu base de datos)
  if (enlace === 'plandecuenta.php') return '/plan-de-cuentas';
  if (enlace === 'usuarios.php') return '/usuarios';
  if (enlace === 'secciones.php') return '/secciones';

  // Ruta por defecto
  return '/';
};

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Sistema POA
          </Typography>
          {user && (
            <>
              <Typography variant="body1" sx={{ mr: 1 }}>
                {user}
              </Typography>
              <IconButton
                edge="end"
                aria-label="account"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                color="inherit"
              >
                <Avatar sx={{ width: 24, height: 24 }} />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        sx={{ width: 240, flexShrink: 0, [`& .MuiDrawer-paper`]: { width: 240 } }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {secciones.map((sec) => (
              <ListItem 
                button 
                key={sec.id} 
                component={Link} 
                to={enlaceToRuta(sec.enlace)}
                onClick={handleMenuClose}
              >
                <ListItemText primary={sec.nombre} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;